export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
/**
 * fetchStatisticDataSuccess
 *
 * Creates an action to signify the successful completion of a data fetch operation.
 *
 * @param {any} data - The data returned from the successful fetch operation.
 *
 * @returns {object} An action with:
 *  - `type`: `FETCH_DATA_SUCCESS`
 *  - `payload`: The fetched data.
 */
export const fetchStatisticDataSuccess = (data: any) => ({
    type: FETCH_DATA_SUCCESS,
    payload: data,
});